import { breakpoint } from '../../../styling/mixins/breakpoints';
import styled from 'styled-components';
import { getColor } from '../../../styling/mixins/colors';
import { cells, section, span } from '../../../styling/utils/grid';
import { hideFor, showFor } from '../../../styling/utils/visibility';

export const StyledCheckout = styled.div`
  padding: 2.4rem 0;
  background-color: ${getColor('grey', 100)};

  ${breakpoint('medium')} {
    padding: 3.2rem 0;
  }
  ${breakpoint('large')} {
    padding: 4rem 0;
  }

  .checkout-content {
    padding: 0;
    ${breakpoint('large')} {
      ${section}
      width: 75%;
    }
  }

  .checkout__wrapper {
    gap: 2.4rem;
    display: flex;
    flex-direction: column;
  }

  .checkout__title {
    line-height: 120%;
    margin-bottom: 1.6rem;
    padding: 0 1.6rem;

    ${breakpoint('large')} {
      padding: unset;
    }
  }
  .checkout__message {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1.2rem;
    background-color: ${getColor('white', 500)};
    border: 1px solid ${getColor('grey', 900)};
    border-radius: 4px;
    margin: 0 1.6rem 2.4rem 1.6rem;
    font-size: 1.6rem;
    ${breakpoint('large')} {
      margin: 0 0 2.4rem 0;
    }
    &-icon {
      font-size: 2.4rem;
      margin-right: 0.8rem;
    }
  }
  .checkout__sections-wrapper {
    ${span(1)}
    ${breakpoint('small')} {
      ${span(2)}
    }
  }

  .cart__section-wrapper {
    ${span(1)}
  }
  .cart__mobilesection-wrapper {
    ${hideFor('large')}
    ${span(1)}
  }
  .cart__desktopsection-wrapper {
    ${span(1)}
    display: none;
    ${breakpoint('large')}{
      display: block;
    }
  }
  .order-summary-header {
    display: none;
    ${breakpoint('large')}{
      display: block;
    }
  }
`;
